import { useQuery } from "react-query";

import { formDataQueryKeys } from "./queryKeys";
import useQSBuilder from "../../hooks/useQSBuilder";
import useApiHelper from "../../services/useApiHelper";
import { IFormData } from "../../models/formData/FormData";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";

export function useFormDataByPerson(agencyId: string, personId: string) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const formData = useQuery({
    queryKey: formDataQueryKeys.byPerson(agencyId, personId),
    queryFn: () =>
      get(
        `/formData/${agencyId}${buildQs({ personId })}`
      ) as unknown as IDefaultResponseWithData<IFormData[]>,
    refetchOnWindowFocus: false,
  });

  return {
    formData,
  };
}
